import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRepaymentLogsURL } from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
const initialState = {
  loading: false
};

const logSlice = createSlice({
  name: "userActivityLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRepaymentLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserRepaymentLogs.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchUserRepaymentLogs.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const fetchUserRepaymentLogs = createAsyncThunk(
  "userActivityLog/fetchUserRepaymentLogs",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getRepaymentLogsURL, {
        params: payload
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
export default logSlice.reducer;
